<template>
<div :class="`column ${size}`">
	<div @click="changeRoute()" :class="`card shadow-box ${hover ? 'hover-allow' : ''}`">
		<div :style="`border: 7px solid ${styles.card_color}`" class="card-content">
			<div class="columns is-mobile is-vcentered">
				<div class="column is-3">
					<figure :class="`image ${fig_size}`">
						<img :src="img" />
					</figure>
				</div>
				<!-- <div v-if="img" class="media-left">
					<figure class="image is-96x96">
						<img :src="img" />
					</figure>
				</div> -->
				<div class="column is-9">
					<p :class="`title ${title_size} mb-0`">{{name}}</p>
					<p class="title is-6">{{description}}</p>
				</div>
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
	name : 'Card',
	props : {
		hover : {
			default : true
		},
		size : {
			default : 'is-4'
		},
		fig_size : {
			default : 'is-64x64'
		},
		title_size : {
			default : 'is-5'
		},
		img : {
			default : null
		},
		name : {
			required : true
		},
		description : {
			required : true
		},
		router_name : {
			default : null
		},
		router_params : {
			type : Object,
			default : null
		},
		styles : {
			type : Object,
			required : true
		}
	},
	data(){
		return {

		}
	},
	methods : {
		changeRoute(){
			console.log(this.router_params)
			if(this.router_name !== null){
				let router_obj = { name : this.router_name }
				if(this.router_params){
					router_obj['params'] = this.router_params
				}
				this.$router.push(router_obj)
			}
		}
	}
}	
</script>
<style scoped>

</style>